import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Breadcrumb,
    Card,
    CardBody,
    Form,
    CardFooter,
} from "react-bootstrap";
import "../assets/css/brandbook.css";
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { AutoComplete } from "primereact/autocomplete";
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";
import { Tooltip } from 'primereact/tooltip';

const Add_minutesofmeeting = ({ onSuccess }) => {
    const { accessToken, userId } = useAuth(); // Get access token for authorization
    const [formData, setFormData] = useState({
        date: '',
        meeting_type: 'Internal',
        meeting_title: '',
        meeting_members: '',
        agenda: '',
        decisions: '',
        action_items: '',
        discussions: '',
        client_updates: ''
    });
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);

    // const [showBrand, setShowBrand] = useState(false);
    // const [showProject, setShowProject] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // Add loading state
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog

    const navigate = useNavigate();


    // Fetch brands from the API
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setBrands(response.data || []);
        } catch (error) {
            console.error("Error fetching brands:", error);
        }
    };

    // Fetch projects with optional brand_id filter
    const fetchProjects = async () => {
        try {
            // Construct the query URL with optional brand_id parameter
            let url = `${config.apiBASEURL}/BrandBookRoutes/fetch-projects`;

            if (selectedBrand && selectedBrand.brand_id) {
                url += `?brand_id=${selectedBrand.brand_id}`;  // Add brand_id to the query string
            }

            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });
            setProjects(response.data.data || []);
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };



    useEffect(() => {
        fetchBrands();
    }, [accessToken]);

    useEffect(() => {
        setSelectedProject(null); // Reset project selection when brand changes
        fetchProjects();
    }, [accessToken, selectedBrand]);



    // Filter brands for autocomplete
    const searchBrands = (event) => {
        const query = event.query.toLowerCase();
        setFilteredBrands(
            brands.filter((brand) =>
                brand.brand_name.toLowerCase().includes(query)
            )
        );
    };

    const searchProjects = (event) => {
        const query = event.query.toLowerCase();
        setFilteredProjects(
            projects.filter((project) =>
                project.project_name.toLowerCase().includes(query)
            )
        );
    };


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedProject) {
            console.error('Project is required.');
            return;
        }
        if (!selectedBrand) {
            console.error('Brand is required.');
            return;
        }
        try {
            const response = await axios.post(`${config.apiBASEURL}/BrandBookRoutes/addMinutesOfMeeting`, {
                ...formData,
                brand_id: selectedBrand ? selectedBrand.brand_id : null,
                project_id: selectedProject ? selectedProject.project_id : null,
                creator_id: userId,
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 201) {
                // Fetch updated taskboard data
                setVideoDialogVisible(true); // Show video dialog
                setTimeout(() => {
                    setVideoDialogVisible(false); // Hide video dialog after 6 seconds
                   
                }, 5000);

            }
        } catch (error) {
            console.error('Error adding meeting minutes:', error);
            setVideocrossDialogVisible(true); // Show video dialog

            setTimeout(() => {
                setVideocrossDialogVisible(false); // Hide video dialog after 6 seconds

            }, 5000);
        } finally {
            setIsLoading(false);
            onSuccess();
        }
    };



    return (
        <>
            <Card className="shadow-0 p-0">
                <Card.Header className="h6 d-flex justify-content-between align-items-center px-0">
                    Add Minutes Of Meeting
                </Card.Header>
                <Card.Body className="pb-0 px-0">
                    <Form>
                        <Row className="mx-0">
                            <Col md={6} lg={6} className="mb-3 px-1">
                                <Form.Label>Meeting Title
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: This title will be visible in the minutes of meeting."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control type="text" name="meeting_title" value={formData.meeting_title} onChange={handleChange} required />
                            </Col>
                            <Col md={6} lg={6} className="mb-3 px-1">
                                <Form.Label>Meeting Type
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Nature of the Meeting that has been Completed."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="select" name="meeting_type" value={formData.meeting_type} onChange={handleChange}>
                                    <option value="Call">Call</option>
                                    <option value="Video_call">Video Call</option>
                                    <option value="In_person">In Person</option>
                                    <option value="Hybrid">Hybrid</option>
                                    <option value="Internal">Internal</option>
                                    <option value="Client_meeting">Client Meeting</option>
                                    <option value="Presentation">Presentation</option>
                                    <option value="Review">Review</option>
                                    <option value="Training">Training</option>
                                    <option value="Brainstorming">Brainstorming</option>
                                </Form.Control>
                            </Col>
                            <Col md={6} lg={6} className="mb-3 px-1">
                                <Form.Label>Date
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Date the meeting has been conducted."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required />
                            </Col>

                            <Col md={6} lg={6} className="mb-3 px-1">
                                <Form.Label>Brand Name</Form.Label>
                                <AutoComplete
                                    value={selectedBrand}
                                    suggestions={filteredBrands}
                                    completeMethod={searchBrands}
                                    field="brand_name"
                                    onChange={(e) => setSelectedBrand(e.value)}
                                    placeholder="Search Brand"
                                    className="w-100"
                                />
                            </Col>

                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Project Name</Form.Label>
                                <AutoComplete
                                    value={selectedProject}
                                    suggestions={filteredProjects}
                                    completeMethod={searchProjects}
                                    field="project_name"
                                    onChange={(e) => setSelectedProject(e.value)}
                                    placeholder="Search Project"
                                    className="w-100"
                                />
                            </Col>
                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Meeting Members
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Names of Meeting Participants / Attendees (Seperated by Commas)."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} name="meeting_members" value={formData.meeting_members} onChange={handleChange} className="h-auto" />
                            </Col>
                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Agenda
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Agenda of the Meeting."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} name="agenda" value={formData.agenda} onChange={handleChange} className="h-auto" />
                            </Col>

                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Action Items
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Actions that has been discussed in this Meeting."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} name="action_items" value={formData.action_items} onChange={handleChange} className="h-auto" />
                            </Col>
                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Discussions
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Elaborate discussions that has been discussed in this Meeting."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} name="discussions" value={formData.discussions} onChange={handleChange} className="h-auto" />
                            </Col>
                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Decisions
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Decisions that has been discussed in this Meeting."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} name="decisions" value={formData.decisions} onChange={handleChange} className="h-auto" />
                            </Col>
                            <Col md={12} lg={12} className="mb-3 px-1">
                                <Form.Label>Client Updates
                                    <i
                                        className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                        data-pr-tooltip="Note: Updates from Clients regarding the Meeting (if any)."
                                        data-pr-position="right"
                                        data-pr-at="right+5 top"
                                        data-pr-my="left center-2"
                                    >
                                    </i>
                                    <Tooltip target=".custom-target-icon" />
                                </Form.Label>
                                <Form.Control as="textarea" rows={3} name="client_updates" value={formData.client_updates} onChange={handleChange} className="h-auto" />
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
                <CardFooter className="border-0 mb-3 px-0">
                    <div className="d-flex justify-content-end">
                        <Button
                            label={isLoading ? 'Saving...' : 'Save'}
                            icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-folder-open'}
                            className="border-0"
                            severity="success"
                            onClick={handleSubmit}
                            disabled={isLoading}
                        />
                    </div>
                </CardFooter>
            </Card>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>
        </>
    );
};


export default Add_minutesofmeeting
